module.exports = __webpack_public_path__ + "img/blue-triangle.fc4aee96.svg";